import { useAemConfig } from '@as-react/common-components';
import { ProductDetailTabTypes } from '@as-react/common-types';
import { useSelector } from 'react-redux';
import { makeGetDetailInformation, makeGetExpertReviews, makeGetProductCareData, makeGetProductReview, makeGetProductTechnicalCategories, } from '../redux/product/selectors/ProductSelector';
import { filterProductCategoryEmptyFeatures, filterProductCategoryFalseBooleanFeatures } from '../util/ProductUtil';
export const useDisplayedProductDetailTabs = (productDetailTabs) => {
    const detailInformation = useSelector(makeGetDetailInformation());
    const hasReviewAverage = Boolean(useSelector(makeGetProductReview()));
    const hasExpertReview = useSelector(makeGetExpertReviews()).length > 0;
    const productCareData = useSelector(makeGetProductCareData());
    const hasProductCare = Boolean(productCareData && Object.keys(productCareData).length);
    const technicalCategories = useSelector(makeGetProductTechnicalCategories());
    const { lang } = useAemConfig();
    const shouldDisplayFeatureCategories = (featureCategories) => {
        if (!(technicalCategories === null || technicalCategories === void 0 ? void 0 : technicalCategories.length) || !(featureCategories === null || featureCategories === void 0 ? void 0 : featureCategories.length)) {
            return false;
        }
        const categoriesIds = technicalCategories.map(({ categoryId }) => categoryId);
        const hasCategories = featureCategories.some(({ id }) => categoriesIds.includes(Number(id)));
        const includedCategoriesIDs = featureCategories.map(({ id }) => Number(id));
        const filteredCategories = technicalCategories
            .map(filterProductCategoryEmptyFeatures)
            .filter(category => category.features.length && includedCategoriesIDs.includes(category.categoryId));
        return hasCategories && filteredCategories.length > 0;
    };
    const shouldDisplayOurPlanetFeatureCategories = (featureCategories) => {
        if (!(technicalCategories === null || technicalCategories === void 0 ? void 0 : technicalCategories.length) || !(featureCategories === null || featureCategories === void 0 ? void 0 : featureCategories.length)) {
            return false;
        }
        const categoriesIds = technicalCategories.map(({ categoryId }) => categoryId);
        const hasCategories = featureCategories.some(({ id }) => categoriesIds.includes(Number(id)));
        const includedCategoriesIDs = featureCategories.map(({ id }) => Number(id));
        const filteredCategories = technicalCategories
            .map(filterProductCategoryEmptyFeatures)
            .map(categories => filterProductCategoryFalseBooleanFeatures(categories, lang))
            .filter(category => category.features.length && includedCategoriesIDs.includes(category.categoryId));
        return hasCategories && filteredCategories.length > 0;
    };
    return productDetailTabs.map(tab => {
        switch (tab.type) {
            case ProductDetailTabTypes.DESCRIPTION:
                tab.shouldDisplay = !!detailInformation.information || !!detailInformation.technicalDescription;
                break;
            case ProductDetailTabTypes.PRODUCT_CARE:
                tab.shouldDisplay = hasProductCare;
                break;
            case ProductDetailTabTypes.REVIEWS: {
                const shouldShowUserReview = hasReviewAverage && tab.showEndUserReview;
                tab.shouldDisplay = shouldShowUserReview || hasExpertReview;
                break;
            }
            case ProductDetailTabTypes.FEATURE_CATEGORIES:
                tab.shouldDisplay = shouldDisplayFeatureCategories(tab.includedCategories);
                break;
            case ProductDetailTabTypes.OUR_PLANET:
                tab.shouldDisplay = shouldDisplayOurPlanetFeatureCategories(tab.ourPlanetFeatures);
                break;
            default:
                tab.shouldDisplay = true;
        }
        return tab;
    });
};
